// ─── COLORS ──────────────────────────────────────────────────────────────────

export const COLORS = {
  TURQUOISE: {
    "25": "#EFFCFD",
    "50": "#AEF5FA",
    "100": "#4EE7F1",
    "200": "#32CED8",
    "300": "#2CB6BF",
    "400": "#26A6AE",
    "500": "#1D878E",
    "600": "#167075",
    "700": "#115B5F",
    "800": "#0B4549",
    "900": "#093136"
  },
  GOLD: {
    "25": "#FBF9F6",
    "50": "#F0E0CF",
    "100": "#E7C6A0",
    "200": "#DDAC70",
    "300": "#C09560",
    "400": "#AA8454",
    "500": "#927047",
    "600": "#7A5D3A",
    "700": "#634B2E",
    "800": "#4C3A23",
    "900": "#362A1B"
  },
  GREEN: {
    "25": "#EDFDF7",
    "50": "#98FCD9",
    "100": "#39ECBB",
    "200": "#0CD3A5",
    "300": "#0ABB91",
    "400": "#07A27D",
    "500": "#068A6B",
    "600": "#037358",
    "700": "#035D47",
    "800": "#014735",
    "900": "#043326"
  },
  RED: {
    "25": "#FCF8F8",
    "50": "#F7E4E1",
    "100": "#F4C7C0",
    "200": "#F2A69C",
    "300": "#EE8679",
    "400": "#EA5E54",
    "500": "#D93E3E",
    "600": "#B53232",
    "700": "#942828",
    "800": "#731D22",
    "900": "#53151E"
  },
  ORANGE: {
    "25": "#FDF8F5",
    "50": "#FBE3D3",
    "100": "#FCC69E",
    "200": "#FEA458",
    "300": "#F8830B",
    "400": "#D77108",
    "500": "#B96006",
    "600": "#9A4F04",
    "700": "#803E02",
    "800": "#682A02",
    "900": "#4C1D04"
  },
  BLUE: {
    "25": "#F8F9FD",
    "50": "#E2E8FA",
    "100": "#C3D2F8",
    "200": "#9FBBF9",
    "300": "#7AA6F7",
    "400": "#4690F5",
    "500": "#2A7CDC",
    "600": "#2166B8",
    "700": "#195396",
    "800": "#113F75",
    "900": "#0E2D54"
  },
  GRAY: {
    "25": "#F9F9F9",
    "50": "#E8E8E8",
    "100": "#D1D1D1",
    "200": "#BABABA",
    "300": "#A4A4A4",
    "400": "#8E8E8E",
    "500": "#797979",
    "600": "#646464",
    "700": "#515151",
    "800": "#3E3E3E",
    "900": "#2C2C2C"
  },
  NEUTRAL: {
    "25": "#F6F8FC",
    "50": "#ECF1F8",
    "100": "#DBE8F5",
    "200": "#ABBFD3",
    "300": "#92A7BC",
    "400": "#7B92A9",
    "500": "#5E7A95",
    "600": "#496682",
    "700": "#284968",
    "800": "#163552",
    "900": "#071F35"
  },
  YELLOW: {
    "25": "#FDF9F1",
    "50": "#FDE4BD",
    "100": "#FFC855",
    "200": "#EBAF01",
    "300": "#D09A01",
    "400": "#B48501",
    "500": "#9B7200",
    "600": "#805E00",
    "700": "#684C00",
    "800": "#503900",
    "900": "#3A2900"
  },
  PINK: {
    "25": "#FDF8FB",
    "50": "#FAE1F3",
    "100": "#F9C1EB",
    "200": "#F99AE6",
    "300": "#F872E0",
    "400": "#F631DB",
    "500": "#D428BD",
    "600": "#B1209D",
    "700": "#911881",
    "800": "#701063",
    "900": "#510D48"
  },
  PURPLE: {
    "25": "#FAF9FD",
    "50": "#EDE5F9",
    "100": "#DBCBF7",
    "200": "#C8AFF6",
    "300": "#B595F3",
    "400": "#9F7AF1",
    "500": "#8961EE",
    "600": "#6E45EB",
    "700": "#4F2AE8",
    "800": "#2F13CB",
    "900": "#250E94"
  },
  BLACK: {
    "25": "rgba(0, 0, 0, 0.02)",
    "50": "rgba(0, 0, 0, 0.08)",
    "100": "rgba(0, 0, 0, 0.16)",
    "200": "rgba(0, 0, 0, 0.24)",
    "300": "rgba(0, 0, 0, 0.33)",
    "400": "rgba(0, 0, 0, 0.41)",
    "500": "rgba(0, 0, 0, 0.49)",
    "600": "rgba(0, 0, 0, 0.58)",
    "700": "rgba(0, 0, 0, 0.66)",
    "800": "rgba(0, 0, 0, 0.80)",
    "900": "rgba(0, 0, 0, 1)"
  },
  WHITE: {
    "25": "rgba(255, 255, 255, 0.02)",
    "50": "rgba(255, 255, 255, 0.08)",
    "100": "rgba(255, 255, 255, 0.16)",
    "200": "rgba(255, 255, 255, 0.24)",
    "300": "rgba(255, 255, 255, 0.33)",
    "400": "rgba(255, 255, 255, 0.41)",
    "500": "rgba(255, 255, 255, 0.49)",
    "600": "rgba(255, 255, 255, 0.58)",
    "700": "rgba(255, 255, 255, 0.66)",
    "800": "rgba(255, 255, 255, 0.80)",
    "900": "#FFFFFF"
  }
} as const;

// ─── SPACINGS ──────────────────────────────────────────────────────────────

export const SPACINGS = {
  0: "0px",
  px: "1px",
  0.5: "2px",
  1: "4px",
  1.5: "6px",
  2: "8px",
  3: "12px",
  4: "16px",
  5: "20px",
  6: "24px",
  7: "28px",
  8: "32px",
  9: "36px",
  10: "40px",
  11: "44px",
  12: "48px",
  13: "52px",
  14: "56px",
  16: "64px",
  18: "72px",
  20: "80px",
  22: "88px",
  24: "96px",
  28: "112px",
  32: "128px",
  36: "144px",
  40: "160px",
  48: "192px"
} as const;

// ─── BORDER RADIUS ───────────────────────────────────────────────────────────

export const BORDER_RADIUS = {
  NONE: "0px",
  XS: "2px",
  SM: "4px",
  MD: "8px",
  LG: "16px",
  XL: "24px",
  XXL: "32px",
  XXXL: "40px",
  "4XL": "64px",
  "6XL": "128px"
} as const;

// ─── EFFECTS ─────────────────────────────────────────────────────────────────

export const SHADOWS = {
  XS: "0 1px 2px 0 rgba(18, 18, 23, 0.10)",
  SM: "0 1px 4px 0 rgba(18, 18, 23, 0.12), 0 1px 2px 0 rgba(18, 18, 23, 0.08)",
  MD: "0 4px 6px -1px rgba(18, 18, 23, 0.08), 0 2px 4px -1px rgba(18, 18, 23, 0.06)",
  LG: "0 10px 15px -3px rgba(18, 18, 23, 0.08), 0 4px 6px -2px rgba(18, 18, 23, 0.05)",
  XL: "0 20px 25px -5px rgba(18, 18, 23, 0.10), 0 10px 10px -5px rgba(18, 18, 23, 0.04)",

  "2XL": "0 25px 50px -12px rgba(18, 18, 23, 0.25)",
  "top-xs": "0px -1px 2px 0px rgba(18, 18, 23, 0.05)",
  "top-sm": "0px -1px 2px 0px rgba(18, 18, 23, 0.06), 0px -1px 3px 0px rgba(18, 18, 23, 0.10)",
  "top-md": "0px -2px 4px -1px rgba(18, 18, 23, 0.06), 0px -4px 6px -1px rgba(18, 18, 23, 0.08)",
  "top-lg": "0px -4px 6px -2px rgba(18, 18, 23, 0.05), 0px -10px 15px -3px rgba(18, 18, 23, 0.08)",
  "top-xl": "0px -10px 10px -5px rgba(18, 18, 23, 0.04), 0px -20px 25px -5px rgba(18, 18, 23, 0.10)",
  "top-2xl": "0px -25px 50px -12px rgba(18, 18, 23, 0.25)",

  "right-xs": "1px 0px 2px 0px rgba(18, 18, 23, 0.05)",
  "right-sm": "1px 0px 4px 0px rgba(18, 18, 23, 0.06), 1px 0px 8px 0px rgba(18, 18, 23, 0.10)",
  "right-md": "2px 0px 4px -1px rgba(18, 18, 23, 0.06), 4px 0px 6px -1px rgba(18, 18, 23, 0.08)",
  "right-lg": "4px 0px 6px -2px rgba(18, 18, 23, 0.05), 10px 0px 15px -3px rgba(18, 18, 23, 0.08)",
  "right-xl": "10px 0px 10px -5px rgba(18, 18, 23, 0.04), 20px 0px 25px -5px rgba(18, 18, 23, 0.10)",
  "right-2xl": "25px 0px 50px -12px rgba(18, 18, 23, 0.25);"
} as const;

// ─── TYPOGRAPHY ──────────────────────────────────────────────────────────────

export const TYPOGRAPHY = {
  h2: { fontSize: "40px", lineHeight: "60px" },
  h3: { fontSize: "32px", lineHeight: "48px" },
  h4: { fontSize: "24px", lineHeight: "32px" },
  h5: { fontSize: "20px", lineHeight: "28px" },
  h6: { fontSize: "18px", lineHeight: "24px" },
  body1: { fontSize: "16px", lineHeight: "24px" },
  body2: { fontSize: "15px", lineHeight: "24px" },
  body3: { fontSize: "14px", lineHeight: "16px" },
  body4: { fontSize: "12px", lineHeight: "16px" },
  button: { fontSize: "16px", lineHeight: "24px", textTransform: "none" }
} as const;

// ─── ICON SIZE ────────────────────────────────────────────────────────────────

export const ICON_SIZE = {
  XS: { width: "7px", height: "7px" },
  SM: { width: "14px", height: "14px" },
  MD: { width: "17px", height: "17px" },
  LG: { width: "20px", height: "20px" },
  XL: { width: "27px", height: "27px" }
} as const;

// ─── SIZES ───────────────────────────────────────────────────────────────────

export const SIZES = {
  xs: "16px",
  "icon-xs": "8px",
  sm: "24px",
  "icon-sm": "16px",
  md: "32px",
  "icon-md": "20px",
  lg: "40px",
  "icon-lg": "24px",
  xl: "48px",
  "icon-xl": "32px"
} as const;
